import {
    Box,
    Button,
    Stack,
    ThumbnailAvatar,
    Typography,
} from "@biggeo/bg-ui/lab";
import { marketplaceLogoPng } from "@biggeo/bg-ui/lab/icons";
import { Routes } from "../../navigation/redux/model";

const DataSampleBanner = () => {
    const onExploreMarketplaceClick = () => {
        window.open(Routes.marketplace, "_blank");
    };

    return (
        <Box
            sx={{
                borderRadius: (theme) => theme.radius.xs3,
                padding: 8,
                backgroundColor: (theme) => theme.palette.primary.container,
            }}
        >
            <Stack
                width="100%"
                gap={2}
                justifyContent="center"
                alignItems="center"
            >
                <ThumbnailAvatar src={marketplaceLogoPng} size="sm" />
                <Typography variant="body4" fontWeight="bold">
                    Dynamic Dataset Samples
                </Typography>
                <Typography
                    variant="body4"
                    sx={{
                        textAlign: "center",
                    }}
                >
                    Dataset samples downloaded from BigGeo Marketplace are
                    available for use here.
                </Typography>
                <Button
                    color="primary"
                    fullWidth
                    onClick={onExploreMarketplaceClick}
                >
                    Explore Marketplace
                </Button>
            </Stack>
        </Box>
    );
};

export default DataSampleBanner;
